import actionTypes from '../../actions/actionTypes'
import { List, fromJS } from 'immutable';
import { PROGRAM_DEFAULT } from '../../constants/state';
import { returnStateIfNoAction } from '../helpers';

const INIT_STATE = fromJS(PROGRAM_DEFAULT.updates)

const setTrue = (state, action) => state.set('hasUpdates', true).set('lastUpdateIn', fromJS(action.payload.path))

const setFalse = (state, action) => state.set('hasUpdates', false).set('lastUpdateIn', List())


function updatesReducer(state = INIT_STATE, action) {
    
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.HAS_UPDATES_SET_TRUE:
            return setTrue(state, action)
        case actionTypes.HAS_UPDATES_SET_FALSE:
            return setFalse(state, action)
        default:
            return state;
    }
}

export default updatesReducer